import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContentComponent } from './../components/content/content.component';
import { ContentQueryComponent } from './../components/contentquery/contentquery.component';
import { ContentrefComponent } from './../components/contentref/contentref.component';
import { DefaultComponent } from './../components/default/default.component';
import { PageComponent } from './../components/page/page.component';
import { PagerefComponent } from './../components/pageref/pageref.component';
import { ContentPathComponent } from './../components/path/content.path.component';
import { SiteComponent } from './../components/site/site.component';
import { ContentRefDirective } from './../directives/contentref.directive';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'WchNgComponentsModule';

@NgModule({
  imports: [CommonModule],
  declarations: [
    PageComponent,
    SiteComponent,
    ContentComponent,
    DefaultComponent,
    PagerefComponent,
    ContentrefComponent,
    ContentQueryComponent,
    ContentPathComponent,
    ContentRefDirective
  ],
  providers: [],
  exports: [
    PageComponent,
    SiteComponent,
    ContentrefComponent,
    PagerefComponent,
    ContentComponent,
    ContentQueryComponent,
    ContentPathComponent
  ],
  entryComponents: [
    ContentQueryComponent,
    ContentPathComponent,
    ContentComponent,
    DefaultComponent,
    ContentrefComponent,
    PagerefComponent,
    PageComponent,
    SiteComponent
  ]
})
export class WchNgComponentsModule {}
